import {Container} from '@orbit-ui/components/container';
import {PageHeader} from '@orbit-ui/components/page-header';
import {PageContent} from '@/components/page-content';
import {PageWrapper} from '@/components/page-wrapper';
import {EventsList} from '../components/events-list';

/**
 * View component for the events history page
 */
export function EventsHistoryView() {
  return (
    <>
      <PageContent>
        <PageWrapper>
          <Container>
            <PageHeader title="Event History" />
            <h3 className="text-lg font-semibold leading-none tracking-tight">
              Authentication Events
            </h3>
            <div className="mt-1 pb-8 text-sm leading-6 text-muted-foreground">
              View your authentication activity to monitor account access and security. This log
              helps you identify unusual login patterns or potential unauthorized access.
            </div>
            <EventsList />
          </Container>
        </PageWrapper>
      </PageContent>
    </>
  );
}
